import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faTimes } from "@fortawesome/free-solid-svg-icons";
import Button from "../../atoms/Button";
import InputField from "../../atoms/InputField";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

export interface SearchBoxProps {
  className?: string;
  variant?: "default" | "toolbar";
  onChange?: (value: string) => void;
  onClick?: (value: string) => void;
}

function SearchBox(props: SearchBoxProps) {
  const [searchTerm, setSearchTerm] = useState("");

  const onSearchChange = (value: string) => {
    setSearchTerm(value);

    if (props.onChange) {
      props.onChange(value);
    }
  };

  const onSearchClick = (value: string) => {
    if (props.onClick) {
      props.onClick(value);
    } else {
      setSearchTerm("");
      if (props.onChange) props.onChange("");
    }
  };

  const renderButton = () => {
    const icon =
      props.onChange && props.onClick === undefined && searchTerm !== ""
        ? faTimes
        : faSearch;

    if (props.variant === "toolbar") {
      return searchTerm !== "" ? (
        <Button
          variant="link-white"
          icon={<FontAwesomeIcon icon={faTimes as IconProp} />}
          type="button"
          onClick={() => onSearchClick(searchTerm)}
        />
      ) : null;
    }

    return (
      <Button
        variant="link-white"
        icon={<FontAwesomeIcon icon={icon as IconProp} />}
        type="button"
        onClick={() => onSearchClick(searchTerm)}
      />
    );
  };

  return (
    <>
      <InputField
        classes={props.className}
        placeholder="Search Phone Numbers"
        value={searchTerm}
        hideErrorMessage={props.variant === "toolbar"}
        onChange={(e) => onSearchChange(e.target.value)}
        onFocus={(e: any) => e.target.select()}
        onKeyDown={(e: any) => {
          if (e.key === "Enter") {
            onSearchClick(searchTerm);
          }
        }}
        left={
          props.variant === "toolbar" ? (
            <FontAwesomeIcon icon={faSearch as IconProp} />
          ) : undefined
        }
        wrapperClasses={
          props.variant === "toolbar"
            ? "my-0 min-h-[42px] rounded-md border-white/35 bg-black/55 px-4 py-0 text-white"
            : undefined
        }
        inputClasses={
          props.variant === "toolbar"
            ? "py-2 text-sm placeholder:text-white/45"
            : undefined
        }
        rightClasses={props.variant === "toolbar" ? "text-white/70" : undefined}
        right={renderButton()}
      />
    </>
  );
}

export default SearchBox;
